import script from "./apply-fail.vue?vue&type=script&lang=ts&setup=true"
export * from "./apply-fail.vue?vue&type=script&lang=ts&setup=true"

import "./apply-fail.vue?vue&type=style&index=0&id=6e8a112c&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e8a112c"]])

export default __exports__